'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _row = require('../basic/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('../basic/col');

var _col2 = _interopRequireDefault(_col);

var _form = require('../basic/form');

var _form2 = _interopRequireDefault(_form);

var _input = require('../basic/input');

var _input2 = _interopRequireDefault(_input);

var _button = require('../basic/button');

var _button2 = _interopRequireDefault(_button);

var _queueAnim = require('../basic/queue-anim');

var _queueAnim2 = _interopRequireDefault(_queueAnim);

var _icon = require('../basic/icon');

var _icon2 = _interopRequireDefault(_icon);

var _misc = require('../tools/misc');

var _misc2 = _interopRequireDefault(_misc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormItem = _form2["default"].Item;
var createForm = _form2["default"].create;


var Query = _react2["default"].createClass({
	displayName: 'Query',
	getInitialState: function getInitialState() {
		return {
			formData: this.props.formData,
			show: this.props.defaultExpand || false
		};
	},
	getDefaultProps: function getDefaultProps() {
		return {
			formData: undefined,
			submitName: "查询",
			onSubmit: function onSubmit(formData) {
				console.log(formData);
			},
			onReset: function onReset() {}
		};
	},
	componentWillMount: function componentWillMount() {
		this.handleClear(); //立即重置表单, 获得表单默认值.
	},
	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var formData = nextProps.formData && nextProps.formData != this.state.formData ? nextProps.formData : this.state.formData;
		var children = void 0;
		if (!nextProps.children.length) {
			children = [nextProps.children];
		} else {
			children = nextProps.children;
		}
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var child = _step.value;

				if (child && (child.props["defaultValue"] || child.props["value"] != undefined)) {
					//注意, 这里defaultValue必须是有意义的值, 因为Input组件默认的DefaultValue是""
					if (child.props["defaultValue"] ? child.props["value"] && child.props["value"] != formData[child.props["name"]] && child.props["value"] != child.props["defaultValue"] : child.props["value"] != formData[child.props["name"]]) {
						formData[child.props["name"]] = child.props["value"];
					}
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator["return"]) {
					_iterator["return"]();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		this.setState({ formData: formData });
	},
	setValue: function setValue(func, name, e) {
		var formData = this.state.formData;
		var value = e.target ? e.target.value : e; //Input 传入的是e, select传入的是value
		formData[name] = value;
		this.setState({ formData: formData });
		if (func) func(e);
	},
	handleSubmit: function handleSubmit(e) {
		e.preventDefault();
		this.props.onSubmit(this.state.formData);
	},
	handleClear: function handleClear(e) {
		if (e) e.preventDefault();
		var formData = {};
		var children = this.props.children;
		for (var i in children) {
			if (children[i] && children[i].props) {
				formData[children[i].props["name"]] = children[i].props["defaultValue"] ? children[i].props["defaultValue"] : null;
			}
		}
		this.setState({ formData: formData });
		this.props.onReset(e);
	},
	render: function render() {
		var _this = this;

		var formData = this.state.formData;
		var formEntity = [];
		var children = void 0;
		if (!this.props.children.length) {
			children = [this.props.children];
		} else {
			children = this.props.children;
		}
		for (var i in children) {
			//遍历组件, 在这里将所有children变成受控组件.
			if (children[i]) {
				var childName = children[i].props["name"];
				var injectProps = {
					onChange: this.setValue.bind(null, children[i].props["onChange"], children[i].props["name"]),
					value: this.state.formData[childName]
				};
				var child = _react2["default"].cloneElement(children[i], injectProps);
				formEntity.push(_react2["default"].createElement(
					_col2["default"],
					{ span: '8', key: i },
					_react2["default"].createElement(
						FormItem,
						{
							label: children[i].props["label"] || children[i].props["labelName"],
							labelCol: { span: 10 },
							wrapperCol: { span: 14 } },
						child
					)
				));
			}
		}
		return _react2["default"].createElement(
			'div',
			null,
			_react2["default"].createElement(
				'p',
				{ className: 'buttons', style: { textAlign: "right", padding: 10 } },
				_react2["default"].createElement(
					_button2["default"],
					{ type: 'primary', onClick: function onClick() {
							_this.setState({ show: !_this.state.show });
						} },
					'查询条件 ',
					this.state.show ? _react2["default"].createElement(_icon2["default"], { type: 'minus-circle-o' }) : _react2["default"].createElement(_icon2["default"], { type: 'plus-circle' })
				)
			),
			_react2["default"].createElement(
				_queueAnim2["default"],
				{ delay: 100, type: ["top"], style: { paddingRight: 15 } },
				this.state.show ? [_react2["default"].createElement(
					_form2["default"],
					{ horizontal: true, key: 'dummy' },
					_react2["default"].createElement(
						_row2["default"],
						null,
						formEntity
					),
					_react2["default"].createElement(
						_row2["default"],
						null,
						_react2["default"].createElement(
							_col2["default"],
							{ span: '8', offset: '16', style: { textAlign: 'right' } },
							_react2["default"].createElement(
								_button2["default"],
								{ type: 'ghost', onClick: this.handleClear },
								'重置条件'
							),
							_react2["default"].createElement(
								_button2["default"],
								{ type: 'primary', onClick: this.handleSubmit },
								this.props.submitName
							)
						)
					)
				)] : null
			)
		);
	}
});

//Query = createForm()(Query);

exports["default"] = Query;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/query.jsx
 ** module id = 622
 ** module chunks = 0
 **/